var React = require('react');

function FullStar (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#FFD531","fillRule":"nonzero","d":"M11.736 8.54c-.275.267-.4.65-.334 1.026l.673 3.914a.436.436 0 0 1-.178.433.436.436 0 0 1-.469.034L7.902 12.1a1.15 1.15 0 0 0-1.08 0l-3.527 1.847a.436.436 0 0 1-.469-.034.436.436 0 0 1-.178-.433l.674-3.914a1.155 1.155 0 0 0-.334-1.025L.134 5.768a.433.433 0 0 1-.11-.454.429.429 0 0 1 .358-.3l3.942-.574a1.16 1.16 0 0 0 .876-.633L6.963.247A.434.434 0 0 1 7.362 0c.172 0 .321.091.398.247l1.763 3.56c.17.342.498.58.877.633l3.94.573a.429.429 0 0 1 .36.3.433.433 0 0 1-.111.455l-2.853 2.773z"}));
}

FullStar.defaultProps = {"width":"15","height":"14","viewBox":"0 0 15 14"};

module.exports = FullStar;

FullStar.default = FullStar;
